import { render, staticRenderFns } from "./CargoModals.vue?vue&type=template&id=28dc914c"
import script from "./CargoModals.vue?vue&type=script&lang=js"
export * from "./CargoModals.vue?vue&type=script&lang=js"
import style0 from "./CargoModals.vue?vue&type=style&index=0&id=28dc914c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports